import VideoBlock from '@components/ui-components/video-block/component.js'

export default {
  components: {
    'video-block-cmp': VideoBlock,
  },
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/video/component.js